import React, { useEffect, useState } from 'react';
import { ShoppingBag, Menu, X, Search } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Collections',
    href: '#collections'
  }, {
    name: 'Limited Editions',
    href: '#limited'
  }, {
    name: 'Zenith Tier',
    href: '#zenith'
  }, {
    name: 'About',
    href: '#about'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0A0A0A]/95 backdrop-blur-md py-4 border-b border-[#C9A962]/20' : 'bg-transparent py-6'}`} data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="flex items-center justify-between" data-id="element-151">
          {/* Logo */}
          <a href="#" className="text-2xl font-bold font-serif tracking-wider text-[#F5F5F0]" data-id="element-152">
            GAMERIE<span className="text-[#C9A962]" data-id="element-153">.</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-154">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-[#F5F5F0]/80 hover:text-[#C9A962] transition-colors tracking-wide" data-id="element-155">
                {link.name}
              </a>)}
          </div>

          {/* Icons */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-156">
            <button className="text-[#F5F5F0] hover:text-[#C9A962] transition-colors" aria-label="Search" data-id="element-157">
              <Search size={20} data-id="element-158" />
            </button>
            <button className="text-[#F5F5F0] hover:text-[#C9A962] transition-colors relative" aria-label="Cart" data-id="element-159">
              <ShoppingBag size={20} data-id="element-160" />
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-[#C9A962] rounded-full" data-id="element-161"></span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-162">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-[#F5F5F0] hover:text-[#C9A962]" data-id="element-163">
              {isMobileMenuOpen ? <X size={24} data-id="element-164" /> : <Menu size={24} data-id="element-165" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-166">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#0A0A0A] border-b border-[#C9A962]/20 overflow-hidden" data-id="element-167">
            <div className="px-4 py-6 space-y-4" data-id="element-168">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-lg font-medium text-[#F5F5F0] hover:text-[#C9A962]" data-id="element-169">
                  {link.name}
                </a>)}
              <div className="pt-4 flex items-center space-x-6 border-t border-[#C9A962]/20" data-id="element-170">
                <button className="flex items-center text-[#F5F5F0] hover:text-[#C9A962]" data-id="element-171">
                  <Search size={20} className="mr-2" data-id="element-172" /> Search
                </button>
                <button className="flex items-center text-[#F5F5F0] hover:text-[#C9A962]" data-id="element-173">
                  <ShoppingBag size={20} className="mr-2" data-id="element-174" /> Cart (1)
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}